export enum EMortgageRateHikeBannerStatus {
  Available = 'available',
  ClosedPreviously = 'closedPreviously',
  ClosedDuringSession = 'closedDuringSession',
}
